import { useState, useEffect } from 'react'
import { useLocation } from 'react-router'
import { styles } from './styles.css'

export const Notification: React.FC = () => {
  const location = useLocation()
  const [isShown, setIsShown] = useState(true)

  useEffect(() => {
    setIsShown(!!location.state?.message)
    const timer = setTimeout(() => {
      setIsShown(false)
      window.history.replaceState({}, document.title) // stateから消してあげないとリロードしても表示される
    }, 5000)

    return () => clearTimeout(timer)
  }, [location.state?.message])

  return (
    isShown &&
    location.state?.message && (
      <div className={styles.notification}>
        <span className={styles.text}>{location.state?.message}</span>
      </div>
    )
  )
}
